import { ensureEndsWith, removePrefix, removeSuffix } from './stringUtils';

export function getUrlWithoutSearchParams(url: string | URL) {
	const urlObject = new URL(url);
	if (urlObject.pathname && urlObject.pathname !== '/') {
		return removeSuffix(urlObject.origin, '/') + urlObject.pathname;
	}
	return urlObject.origin;
}

export function withBaseUrl(baseUrl: string, path: string) {
	return ensureEndsWith(baseUrl, '/') + removePrefix(path, '/');
}

export function domainFromEmail(emailAddress: string) {
	return emailAddress.substring(emailAddress.lastIndexOf('@') + 1);
}
